export const SpatialIndex = Object.freeze({
  H3: 'h3',
  S2: 's2',
  QUADBIN: 'quadbin'
});
